/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonActions, FormActionPipelines, FormFlowState } from '@gh/builder-shared';
import { UoMDimension } from '@gh/builder-shared-data';
import { EnumDictionary, getDialogInitData } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { DialogInput, FormMode, NotificationService } from '@gh/core-ui';
import { assign } from 'lodash';
import { UomDetailsBusinessService } from '../../resources/uom-details-business.service';
import { UomDetails } from '../../resources/uom-details.model';
import { UomDetailsDialogFormState } from './uom-details-dialog-form.service';

export interface UomDialogConfig {
  id?: ID;
}

@Component({
  standalone: false,
  selector: 'gh-uom-details-dialog',
  templateUrl: 'uom-details-dialog.component.html',
  styleUrls: ['uom-details-dialog.component.scss'],
  viewProviders: [UomDetailsDialogFormState],
})
export class UomDetailsDialogComponent implements DialogInput<UomDialogConfig>, OnInit {
  dimensions: EnumDictionary<UoMDimension>;

  input: UomDialogConfig;

  constructor(public dialogRef: MatDialogRef<UomDialogConfig>,
              @Inject(MAT_DIALOG_DATA) private dialogData: any,
              public form: UomDetailsDialogFormState,
              private businessService: UomDetailsBusinessService,
              private actions: CommonActions,
              private notificationService: NotificationService,
              private pipelines: FormActionPipelines) {
  }

  get title(): string {
    return {
      [FormMode.CreateMode]: 'lbl_uom_create',
      [FormMode.EditMode]: 'lbl_uom_edit',
      [FormMode.ViewMode]: 'lbl_uom_view',
    }[this.form.mode];
  }

  ngOnInit(): void {
    const { uomDetails, ...init } = getDialogInitData(this.dialogData);

    assign(this, init);

    this.form.build(uomDetails);
  }

  onSubmit(): void {
    const flow = this.pipelines.process({
      execute: this.actions.execute((state: FormFlowState<UomDetails>) =>
        this.businessService.save(state.value)),
      finish: (state) => {
        this.dialogRef.close(state.value);
        if (state.form.editMode) {
          this.notificationService.warning('msg_uom_warning');
        }
      },
    });

    flow.run({ form: this.form, value: this.form.submitValue, trigger: '' });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

}
